'use client';
import React from 'react';
import Link from 'next/link';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useLanguage } from '@/lib/LanguageContext';
import { getTranslations } from '@/lib/i18n';

// metadata removed - client component

const relatedPosts = [
  {
    slug: 'smartwatches-salud-conectada',
    titleEs: 'Smartwatches y Salud Conectada: Revolucionando la Monitorización de Pacientes en Chile',
    titleFr: 'Smartwatches et Santé Connectée : Révolutionner la Surveillance des Patients au Chili',
    image: 'https://innobox.cl/wp-content/uploads/2025/04/Smartwatches--637x446.png',
    alt: 'Smartwatches y salud conectada - dispositivos wearables para monitorización de pacientes',
    dateEs: 'abril 22, 2025',
    dateFr: '22 avril 2025',
  },
  {
    slug: 'ciberseguridad-chile-2024',
    titleEs: 'Ciberseguridad en Chile: Aumento del 30% en Cibercrimen Organizado durante 2024',
    titleFr: 'Cybersécurité au Chili : Augmentation de 30% de la Cybercriminalité Organisée en 2024',
    image: 'https://innobox.cl/wp-content/uploads/2025/04/ciberseguridad-637x446.png',
    alt: 'Ciberseguridad en Chile - escudo digital protegiendo datos empresariales',
    dateEs: 'abril 22, 2025',
    dateFr: '22 avril 2025',
  },
];

const tags = ['Educación Digital', 'E-learning', 'Tecnología', 'Chile', 'Universidad', 'Plataformas Online'];

export default function BlogPostElearningPage() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  const b = t.blog;
  const isFr = language === 'fr';

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Nunito Sans', 'Raleway', arial, sans-serif" }}>
      <Navbar />
      <section className="relative overflow-hidden" style={{ paddingTop: '160px', paddingBottom: '80px', backgroundColor: '#0a0a0a' }}>
        <div className="absolute top-20 right-10 opacity-20 hidden lg:block">
          <img src="https://innobox.cl/wp-content/uploads/2021/07/Dots-4.svg" alt="" className="w-40 h-40" />
        </div>
        <div className="absolute bottom-0 left-0 opacity-10 hidden lg:block">
          <img src="https://innobox.cl/wp-content/uploads/2021/07/Abstract-Circle.svg" alt="" className="w-64 h-64" />
        </div>
        <div className="max-w-[1200px] mx-auto px-[35px] relative z-10">
          <nav className="mb-8 flex items-center gap-2 text-sm" style={{ color: '#888' }}>
            <Link href="/" className="hover:text-[#1AEF0F] transition-colors">{b.breadcrumbHome}</Link>
            <span>/</span>
            <Link href="/#noticias" className="hover:text-[#1AEF0F] transition-colors">{b.breadcrumbBlog}</Link>
            <span>/</span>
            <span style={{ color: '#1AEF0F' }}>{isFr ? 'Plateformes d\'Éducation en Ligne' : 'Plataformas de Educación Online'}</span>
          </nav>
          <div className="max-w-[800px]">
            <div className="inline-flex items-center gap-2 mb-6 px-4 py-2" style={{ border: '1px solid #1AEF0F', color: '#1AEF0F', fontSize: '13px', letterSpacing: '2px' }}>
              <i className="fas fa-graduation-cap" />
              <span>{isFr ? 'ÉDUCATION NUMÉRIQUE' : 'EDUCACIÓN DIGITAL'}</span>
            </div>
            <h1 className="text-white font-bold mb-6" style={{ fontSize: 'clamp(28px, 3.5vw, 50px)', fontFamily: "'Titillium Web', sans-serif", lineHeight: '1.2' }}>
              {isFr
                ? <>Université du Chili : &ldquo;Les plateformes d&apos;éducation en ligne enregistrent plus de <span style={{ color: '#1AEF0F' }}>342 000</span> utilisateurs actifs&rdquo;</>
                : <>Universidad de Chile: &ldquo;Plataformas de Educación Online registran más de <span style={{ color: '#1AEF0F' }}>342 000</span> usuarios activos&rdquo;</>
              }
            </h1>
            <div className="flex items-center gap-4 flex-wrap" style={{ color: '#888', fontSize: '14px' }}>
              <span className="flex items-center gap-2"><i className="fas fa-calendar-alt" style={{ color: '#1AEF0F' }} />{isFr ? '22 avril 2025' : 'abril 22, 2025'}</span>
              <span className="flex items-center gap-2"><i className="fas fa-user" style={{ color: '#1AEF0F' }} />Innobox</span>
              <span className="flex items-center gap-2"><i className="fas fa-clock" style={{ color: '#1AEF0F' }} />{isFr ? '7 min de lecture' : '7 min de lectura'}</span>
            </div>
          </div>
        </div>
      </section>

      <section style={{ backgroundColor: '#111' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <img src="https://innobox.cl/wp-content/uploads/2025/04/e-learning-637x446.png" alt="E-learning - plataformas de educación online en Chile con estudiantes usando computadores" className="w-full" style={{ display: 'block', maxHeight: '500px', objectFit: 'cover' }} />
        </div>
      </section>

      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#fff' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-16">
            <article className="lg:col-span-2">
              <p style={{ fontSize: '18px', color: '#333', lineHeight: '1.9', marginBottom: '28px', fontWeight: '500' }}>
                Un estudio de la Universidad de Chile revela que las plataformas de educación online han alcanzado más de 342.000 usuarios activos, marcando un hito en la transformación digital de la educación superior en el país.
              </p>
              <h2 className="font-bold text-black mb-4" style={{ fontSize: '24px', fontFamily: "'Titillium Web', sans-serif" }}>El Auge del E-learning en Chile</h2>
              <p style={{ fontSize: '16px', color: '#505050', lineHeight: '1.9', marginBottom: '24px' }}>
                La pandemia aceleró la adopción de plataformas digitales en la educación, y Chile no fue la excepción. Las universidades e institutos han invertido significativamente en infraestructura tecnológica para soportar el crecimiento exponencial de usuarios en sus plataformas de aprendizaje en línea.
              </p>
              <p style={{ fontSize: '16px', color: '#505050', lineHeight: '1.9', marginBottom: '24px' }}>
                Plataformas como Moodle, Canvas y soluciones propias han sido adoptadas masivamente, permitiendo a estudiantes acceder a contenidos, participar en clases sincrónicas y obtener certificaciones desde cualquier lugar del mundo.
              </p>
              <blockquote className="my-10 pl-6" style={{ borderLeft: '4px solid #1AEF0F', backgroundColor: '#f9f9f9', padding: '24px 24px 24px 28px' }}>
                <p style={{ fontSize: '18px', color: '#111', lineHeight: '1.7', fontStyle: 'italic', margin: 0 }}>
                  &ldquo;La educación digital no es el futuro, es el presente. Las instituciones que no se adapten quedarán rezagadas en la formación de profesionales competitivos.&rdquo;
                </p>
                <cite className="block mt-4" style={{ fontSize: '14px', color: '#888', fontStyle: 'normal' }}>— Rector Universidad de Chile, 2025</cite>
              </blockquote>
              <h2 className="font-bold text-black mb-4" style={{ fontSize: '24px', fontFamily: "'Titillium Web', sans-serif" }}>Cifras que Hablan por Sí Solas</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 my-10">
                {[
                  { value: '342K+', labelEs: 'Usuarios activos en plataformas e-learning', labelFr: 'Utilisateurs actifs sur les plateformes e-learning' },
                  { value: '85%', labelEs: 'Tasa de satisfacción estudiantil', labelFr: 'Taux de satisfaction étudiante' },
                  { value: '3x', labelEs: 'Crecimiento en oferta de cursos online', labelFr: 'Croissance de l\'offre de cours en ligne' },
                ].map((stat, i) => (
                  <div key={i} className="p-6 text-center" style={{ border: '1px solid #E2E2E2', backgroundColor: '#f9f9f9' }}>
                    <div className="font-bold mb-2" style={{ fontSize: '28px', color: '#1AEF0F', fontFamily: "'Titillium Web', sans-serif" }}>{stat.value}</div>
                    <div style={{ fontSize: '13px', color: '#505050', lineHeight: '1.4' }}>{isFr ? stat.labelFr : stat.labelEs}</div>
                  </div>
                ))}
              </div>
              <h2 className="font-bold text-black mb-4" style={{ fontSize: '24px', fontFamily: "'Titillium Web', sans-serif" }}>
                {isFr ? 'Le Rôle de la Technologie dans l\'Éducation' : 'El Rol de la Tecnología en la Educación'}
              </h2>
              <p style={{ fontSize: '16px', color: '#505050', lineHeight: '1.9', marginBottom: '24px' }}>
                {isFr ? 'Chez Innobox, nous accompagnons les institutions éducatives dans leur transformation numérique avec des solutions d\'infrastructure, de cybersécurité et de formation qui permettent de soutenir des environnements d\'apprentissage en ligne robustes et sécurisés.' : 'En Innobox, acompañamos a instituciones educativas en su transformación digital con soluciones de infraestructura, ciberseguridad y capacitación que permiten sostener entornos de aprendizaje en línea robustos y seguros.'}
              </p>
              <div className="mt-12 pt-8" style={{ borderTop: '1px solid #E2E2E2' }}>
                <p className="font-semibold text-black mb-4" style={{ fontSize: '14px', letterSpacing: '1px' }}>{isFr ? 'ÉTIQUETTES :' : 'ETIQUETAS:'}</p>
                <div className="flex flex-wrap gap-2">
                  {tags.map((tag, i) => (
                    <span key={i} className="px-4 py-2" style={{ border: '1px solid #E2E2E2', fontSize: '13px', color: '#505050', backgroundColor: '#f9f9f9' }}>{tag}</span>
                  ))}
                </div>
              </div>
            </article>

            <aside className="lg:col-span-1">
              <div className="mb-10 p-8" style={{ backgroundColor: '#0a0a0a' }}>
                <div className="flex items-center gap-4 mb-5">
                  <div className="flex items-center justify-center flex-shrink-0" style={{ width: '60px', height: '60px', backgroundColor: '#1AEF0F', borderRadius: '50%' }}>
                    <i className="fas fa-user text-black text-xl" />
                  </div>
                  <div>
                    <p className="font-bold text-white" style={{ fontSize: '16px', fontFamily: "'Titillium Web', sans-serif", margin: 0 }}>Innobox</p>
                    <p style={{ fontSize: '13px', color: '#888', margin: 0 }}>{isFr ? 'Équipe Éditoriale' : 'Equipo Editorial'}</p>
                  </div>
                </div>
                <p style={{ fontSize: '14px', color: '#aaa', lineHeight: '1.7', margin: 0 }}>
                  {isFr ? 'L\'équipe Innobox partage des connaissances sur la technologie, la transformation numérique et les tendances du secteur IT au Chili et en Amérique latine.' : 'El equipo de Innobox comparte conocimiento sobre tecnología, transformación digital y tendencias del sector TI en Chile y Latinoamérica.'}
                </p>
              </div>
              <div className="p-8" style={{ backgroundColor: '#1AEF0F' }}>
                <p className="font-bold text-black mb-3" style={{ fontSize: '18px', fontFamily: "'Titillium Web', sans-serif", lineHeight: '1.3' }}>
                  {isFr ? 'Besoin de solutions e-learning pour votre institution ?' : '¿Necesitas soluciones e-learning para tu institución?'}
                </p>
                <p style={{ fontSize: '14px', color: '#0a0a0a', lineHeight: '1.6', marginBottom: '20px' }}>
                  {isFr ? 'Nous accompagnons les institutions éducatives dans leur transformation numérique.' : 'Acompañamos a instituciones educativas en su transformación digital.'}
                </p>
                <a href="mailto:info@innobox.cl" className="group relative inline-flex items-center overflow-hidden border border-black text-black bg-transparent w-full justify-center" style={{ padding: '12px 24px', fontSize: '14px', fontWeight: 'bold', transition: 'all 300ms ease-out' }}>
                  <span className="relative z-10 transition-colors duration-300 group-hover:text-white">{b.ctaBtnContact}</span>
                  <span className="absolute inset-0 bg-black transform translate-x-full group-hover:translate-x-0 transition-transform duration-300" style={{ zIndex: 0 }} />
                </a>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <section style={{ paddingTop: '70px', paddingBottom: '80px', backgroundColor: '#f5f5f5' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <h2 className="font-bold text-black mb-10" style={{ fontSize: 'clamp(22px, 2vw, 30px)', fontFamily: "'Titillium Web', sans-serif" }}>{b.relatedTitle}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {relatedPosts.map((post, i) => (
              <article key={i} className="group bg-white flex flex-col">
                <div className="overflow-hidden">
                  <Link href={`/blog/${post.slug}`}>
                    <img src={post.image} alt={post.alt} className="w-full transition-transform duration-500 group-hover:scale-105" style={{ display: 'block', aspectRatio: '637/446', objectFit: 'cover' }} />
                  </Link>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <p style={{ fontSize: '13px', color: '#888', marginBottom: '10px' }}>{isFr ? post.dateFr : post.dateEs}</p>
                  <h3 className="font-semibold flex-1" style={{ fontSize: '16px', fontFamily: "'Titillium Web', sans-serif", lineHeight: '1.5', marginBottom: '16px' }}>
                    <Link href={`/blog/${post.slug}`} className="text-black hover:text-[#1AEF0F] transition-colors duration-300">{isFr ? post.titleFr : post.titleEs}</Link>
                  </h3>
                  <Link href={`/blog/${post.slug}`} className="inline-flex items-center gap-2 font-semibold hover:gap-3 transition-all duration-300" style={{ fontSize: '14px', color: '#1AEF0F' }}>
                    {isFr ? 'Lire l\'article' : 'Leer artículo'} <i className="fas fa-arrow-right text-xs" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
          <div className="mt-10 text-center">
            <Link href="/#noticias" className="group relative inline-flex items-center overflow-hidden border border-black text-black bg-transparent" style={{ padding: '14px 36px', fontSize: '15px', fontWeight: '500', transition: 'all 300ms ease-out' }}>
              <span className="relative z-10 transition-colors duration-300 group-hover:text-white">{isFr ? 'Voir tous les articles' : 'Voir tous les articles'}</span>
              <span className="absolute inset-0 bg-black transform translate-x-full group-hover:translate-x-0 transition-transform duration-300" style={{ zIndex: 0 }} />
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
